import generateCreateDefaultState from './generateCreateDefaultState';
import createJobDefaultReducer from './createJobDefaultReducer';

export default (
  state = generateCreateDefaultState('PERSONAL_HELPER'),
  action
) => {
  return createJobDefaultReducer('PERSONAL_HELPER', action, state);
};
